import axios, { AxiosPromise } from 'axios';
import {
    ImportGoogleCSVRequest,
    ImportGoogleCSVResponse,
    IsUniqueFileImportRequest,
} from '../sic-lib/types/GoogleImportCSV';
import { apiInstance as instance } from './';

let googleCSV_cancel: any;
/**
 * Makes a HTTP request for the client's new & recent items
 * @param data
 */
export function googleCSVImport(
    data: ImportGoogleCSVRequest,
): AxiosPromise<ImportGoogleCSVResponse> {
    if (googleCSV_cancel) googleCSV_cancel();

    return instance.post(
        '/CSVImport/Google/' + data.clientId,
        {
            FileName: data.fileName + '.csv',
            fileData: data.json,
        },
        {
            cancelToken: new axios.CancelToken(function executor(c) {
                googleCSV_cancel = c;
            }),
            headers: {
                'Content-Type': 'application/json',
            },
        },
    );
}

export function isUniqueFileImport(
    data: IsUniqueFileImportRequest,
): AxiosPromise<ImportGoogleCSVResponse> {
    if (googleCSV_cancel) googleCSV_cancel();

    return instance.post(
        '/CSVImport/Unique/' + data.clientId,
        {
            FileName: data.fileName,
            FileSize: data.fileSize,
        },
        {
            cancelToken: new axios.CancelToken(function executor(c) {
                googleCSV_cancel = c;
            }),
            headers: {
                'Content-Type': 'application/json',
            },
        },
    );
}

////import { API_BASE_URL } from '../utils/constants';
////import axios, { CancelToken } from 'axios';

//export function googleCSVImport(clientId: number, json: JSON, token: CancelToken) {

//    const jwt = localStorage.getItem('token');

//    const data = JSON.stringify(json)

//    return axios({
//        cancelToken: token,
//        method: 'POST',
//        url: `${API_BASE_URL}/CSVImport/Google/${clientId}`,
//        data: {
//            FileName: 'test.csv',
//            fileData: json
//        },
//        headers: {
//            'Content-Type': 'application/json',
//            'Authorization': `Bearer ${jwt}`
//        }
//    });
//}

//export function isUniqueFileImport(clientId: number, fileSize: number, token: CancelToken, fileName: string = "") {

//    const jwt = localStorage.getItem('token');

//    return axios({
//        cancelToken: token,
//        method: 'POST',
//        url: `${API_BASE_URL}/CSVImport/Google/${clientId}`,
//        data: {
//            FileName: fileName,
//            FileSize: 64
//        },
//        headers: {
//            'Content-Type': 'application/json',
//            'Authorization': `Bearer ${jwt}`
//        }
//    });
//}

//export function zapierCSVImport(clientId: number, json: JSON, token: CancelToken) {

//    const jwt = localStorage.getItem('token');

//    const data = JSON.stringify(json)

//    return axios({
//        cancelToken: token,
//        method: 'POST',
//        url: `${API_BASE_URL}/CSVImport/Zoho/${clientId}`,
//        data: {
//            FileName: 'test.csv',
//            fileData: data
//        },
//        headers: {
//            'Content-Type': 'application/json',
//            'Authorization': `Bearer ${jwt}`
//        }
//    });
//}
